/**
* @development 本地开发
* @production 正式生产环境
* @test 测试环境
* */
const env = process.env.VUE_APP_MODE


const hostsList = {
  // development: '/manager/admin',//开发环境使用代理
  production: 'https://api.next.hxxbaby.com/',
  test: 'http://apitest.hexiaoxiang.com/',
}
const appidList = {
  development: 'wx4ece837666523ebd',
  production: 'wx05d995b24ad77759',
  test: 'wx4ece837666523ebd',
}


const worksLinkList = {
  development: 'https://test.hexiaoxiang.com/temp/evaluation_share.html',
  test: 'https://qa.hexiaoxiang.com/goods/purchase/purchase.html',
  production: 'https://yw.hexiaoxiang.com/goods/purchase.html'
}
const publicPathList = {
  development: '/',
  test: '/goods/purchase/',
  production: 'https://sc2.hexiaoxiang.com/h5/purchase/'
}
const host = hostsList[env]
const appid = appidList[env]
const worksLink = worksLinkList[env]
const publicPath = publicPathList[env]
export {
  appid, host, publicPath, worksLink
}

